export const Question = () => (
  <svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.25 15.75C4.1075 15.75 0.75 12.3925 0.75 8.25C0.75 4.1075 4.1075 0.75 8.25 0.75C12.3925 0.75 15.75 4.1075 15.75 8.25C15.75 12.3925 12.3925 15.75 8.25 15.75Z"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.24998 9.29175V9.08342C8.24998 8.40259 8.67081 8.03342 9.09248 7.75009C9.50415 7.47259 9.91665 7.11092 9.91665 6.44425C9.91665 5.52342 9.17081 4.77759 8.24998 4.77759C7.32915 4.77759 6.58331 5.52342 6.58331 6.44425"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.24832 11.1667C8.01832 11.1667 7.83166 11.3534 7.83332 11.5834C7.83332 11.8134 8.01999 12.0001 8.24999 12.0001C8.47998 12.0001 8.66665 11.8134 8.66665 11.5834C8.66665 11.3534 8.47998 11.1667 8.24832 11.1667Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
